import type { FaireProductEntity } from "../../entity_types/product";

export const p_rhx4kpqxfq: FaireProductEntity = {
  token: "p_rhx4kpqxfq",
  type: "product",
  name: "Freeze Dried Strawberry",
  brandToken: "b_d7mymnraud",
  brandName: "Big Green Organic Food",
  imageUrl:
    "https://cdn.faire.com/fastly/1a7576a8c63368ca2836ff00b88213b213f5e1c014d2eaddaae8b5a82ef70e79.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d9024cc3dd7da622ed9522166f942ec8ebeb86f35af678eca2c12736385b5c8.jpeg",
    "https://cdn.faire.com/fastly/1a467c62488eb1db672e52e2633428499c125e270188b4bd62cc133daabb5689.png",
    "https://cdn.faire.com/fastly/be69f5367705cb411eb808973853210718521ec0d675c4161fdc2eba559b457b.png",
  ],
  priceDollars: 1.94,
  description:
    "Freeze Dried Strawberry \n\nDisclaimer: WARNING: This product can expose you to chemicals including arsenic, which is known to the State of California to cause cancer. For more information go to www.P65Warnings.ca.gov.",
  tags: [],
  msrpDollars: 2.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:34.659Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
